import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { COMMON_API } from '../../CommonAPI';

const EditConnectUs = () => {
    const { id } = useParams();
    const [form, setForm] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const fetchContactInfo = async () => {
            try {
                const token = sessionStorage.getItem('authToken');
                const res = await axios.get(`${COMMON_API}/api/connectus/get-connectus`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const info = res.data.data.find(item => item.id === parseInt(id));
                if (info) {
                    setForm(info);
                }
            } catch (error) {
                toast.error('Failed to load contact info');
            }
        };
        fetchContactInfo();
    }, [id]);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('authToken');
            await axios.put(`${COMMON_API}/api/connectus/edit-connectus`, form, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            toast.success('Contact info updated!');
            navigate('/connectus');
        } catch {
            toast.error('Update failed');
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow space-y-4">
                <h2 className="text-2xl font-semibold mb-4">Edit Contact Info</h2>

                <input type="hidden" name="id" value={form.id || ''} />

                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={form.email || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <input
                    type="text"
                    name="phoneno"
                    placeholder="Phone Number"
                    value={form.phoneno || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <input
                    type="text"
                    name="fb_link"
                    placeholder="Facebook Link"
                    value={form.fb_link || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <input
                    type="text"
                    name="insta_link"
                    placeholder="Instagram Link"
                    value={form.insta_link || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <input
                    type="text"
                    name="twitter_link"
                    placeholder="Twitter Link"
                    value={form.twitter_link || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <input
                    type="text"
                    name="linked_in_link"
                    placeholder="LinkedIn Link"
                    value={form.linked_in_link || ''}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                />

                <button
                    type="submit"
                    className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
                >
                    Update
                </button>
            </form>
        </div>
    );
};

export default EditConnectUs;
